import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Heart } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { SiteNav } from "@/components/SiteChrome";
import { ExitQuestion } from "@/components/ExitQuestion";

export default function TrialExit() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/trial-exit/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  return (
    <div className="relative z-10 min-h-screen bg-background"><SiteNav />
      <div className="max-w-2xl mx-auto px-6 py-14" data-testid="trial-exit-page">
        {err && <p className="rounded-xl bg-rose-50 border border-rose-200 p-4" data-testid="trial-exit-error">{err}. Please use the link from your email.</p>}
        {d && (done || d.done ? (
          <div className="text-center fade-up" data-testid="trial-exit-thanks">
            <Heart className="h-10 w-10 text-pinkb mx-auto" />
            <h1 className="font-serif uppercase text-3xl text-navy mt-4">Thank you.</h1>
            <p className="text-muted-foreground mt-3">That really helps me make the club better. Your account is still here whenever you're ready.</p>
            <Link to="/app/membership" data-testid="trial-exit-rejoin" className="mt-6 inline-block rounded-full bg-navy hover:bg-navy/90 text-white px-6 py-2.5 text-sm transition-colors">See memberships</Link>
          </div>
        ) : (
          <div className="space-y-8 fade-up">
            <div>
              <div className="eyebrow mb-3">The Roots Club · one quick question</div>
              <h1 className="font-serif uppercase text-4xl text-navy leading-[0.95]">What stopped you joining{d.name ? `, ${d.name}` : ""}?</h1>
              <p className="mt-3 text-muted-foreground">Tap the one that fits best. Lindsay reads every answer.</p>
            </div>
            <ExitQuestion onSubmit={(b) => api.post(`/trial-exit/${token}`, b)} onDone={() => setDone(true)} />
          </div>
        ))}
      </div>
    </div>
  );
}
